import { render, staticRenderFns } from "./EditRecruitingProfileEducation.vue?vue&type=template&id=5e319025&scoped=true&"
import script from "./EditRecruitingProfileEducation.vue?vue&type=script&lang=ts&"
export * from "./EditRecruitingProfileEducation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e319025",
  null
  
)

export default component.exports